import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12l-3 -3h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2z","key":"svg-0"}],["path",{"d":"M15 12l3 -3h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2z","key":"svg-1"}],["path",{"d":"M12 15l-3 3v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1v-2z","key":"svg-2"}],["path",{"d":"M12 9l-3 -3v-2a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v2z","key":"svg-3"}]]

const IconDeviceGamepad3 = createReactComponent('outline', 'device-gamepad-3', 'DeviceGamepad3', __iconNode);

export default IconDeviceGamepad3;